import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
const state = {
  token: localStorage.getItem("token"),
  username: localStorage.getItem("username"),
  nickname: localStorage.getItem("nickname"),
  usertype: localStorage.getItem("usertype") || 1,
  menuPath: localStorage.getItem("menuPath")
};
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
    localStorage.setItem("token", token);
  },
  SET_USERNAME: (state, username) => {
    state.username = username;
    localStorage.setItem("username", username);
  },
  SET_NICKNAME: (state, nickname) => {
    state.nickname = nickname;
    localStorage.setItem("nickname", nickname);
  },
  SET_USERTYPE: (state, usertype) => {
    state.usertype = usertype;
    localStorage.setItem("usertype", usertype);
  },
  SET_MENUPATH: (state, menuPath) => {
    state.menuPath = menuPath;
    localStorage.setItem("menuPath", menuPath);
  }
};
const actions = {
  login({ commit }, token) {
    commit("SET_TOKEN", token);
  },
  // user logout
  logout({ commit, state }) {
    commit("SET_TOKEN", "");
  },
  username({ commit }, username) {
    commit("SET_USERNAME", username);
  },
  nickname({ commit }, nickname) {
    commit("SET_NICKNAME", nickname);
  },
  usertype({ commit }, usertype) {
    commit("SET_USERTYPE", usertype);
  },
  menuPath({ commit }, menuPath) {
    commit("SET_MENUPATH", menuPath);
  }
};
export default new Vuex.Store({
  actions,
  mutations,
  state
});



// WEBPACK FOOTER //
// ./src/store/index.js